import extractQuestionnaireData from '../../data_management/extractQuestionnaireData';
import {sortByName} from '../../data_management/sorters/sort_by_name';
import {sortByCreatedAtDesc} from "../../data_management/sorters/sort_by_created_at_desc";
import {Loader} from '../common/loader';

const Questionnaires = function ($location, $element, localize, initialDataInteractor, $scope, questionnairesInteractor, eventsService) {
    const $ctrl = this;

    $ctrl.questionnaires = [];
    $ctrl.filterString = '';
    $ctrl.sortByField = 'title';
    $ctrl.localize = localize;

    $ctrl.$onInit = function () {
        $ctrl.loader = new Loader($element[0]);
        initialDataInteractor.ensureInitializedSession().then(() => {
            $ctrl.questionnaires = extractQuestionnaireData(initialDataInteractor).sort(sortByName);
            $ctrl.loader.remove();
            $ctrl.loaded = true;
            $scope.$digest();
        });
    };

    $ctrl.newQuestionnaire = function () {
        return questionnairesInteractor.addNewQuestionnaire().then(newQuestionnaireId => {
            $location.path(`/questionnaires/${newQuestionnaireId}/edit`);
            $scope.$apply();
        });
    };

    $ctrl.deleteQuestionnaire = function (questionnaire) {
        return questionnairesInteractor.deleteQuestionnaire(questionnaire.id)
            .then(() => {
                eventsService.publishSystemMessage('Questionnaire deleted');
                $scope.$digest();
            }, status => {
                eventsService.publishSystemError('Questionnaire not deleted. Error ' + status);
                $scope.$apply();
            })
    };

    $ctrl.getQuestionnaireId = function (questionnaire) {
        return questionnaire.id;
    };

    $ctrl.duplicate = function (questionnaire) {
        return questionnairesInteractor.duplicateQuestionnaire(questionnaire.id)
            .then(data => {
                $ctrl.questionnaires.push({
                    name: data.title,
                    id: data.id
                });
                eventsService.publishSystemMessage('Questionnaire Duplicated');
                $scope.$digest();
            }, status => {
                eventsService.publishSystemError('Questionnaire failed to be duplicated. Error ' + status);
            });
    };

    $ctrl.displayedQuestionnaires = function () {
        var sorter;
        if ($ctrl.sortByField === 'title') sorter = sortByName;
        else sorter = sortByCreatedAtDesc;
        return $ctrl.filterString.isEmpty ? $ctrl.questionnaires.sort(sorter) : filteredQuestionnaires($ctrl.filterString).sort(sorter);
    };

    function filteredQuestionnaires(string) {
        return $ctrl.questionnaires
            .filter(q => q.name.toUpperCase().indexOf(string.toUpperCase()) >= 0);
    }

    $ctrl.userDidSelectQuestionnaire = function (questionnaire) {
        $scope.$evalAsync(() => {
            let path = `/questionnaires/${questionnaire.id}`;
            $location.path(path);
        });
    };

    $ctrl.userDidClickEdit = function (questionnaire) {
        return Promise.resolve().then(() => $scope.$evalAsync(() => {
            let path = `/questionnaires/${questionnaire.id}/edit`;
            $location.path(path);
        }));
    }
};

export default {
    name: 'questionnaires',
    obj: {
        controller: Questionnaires,
        templateUrl: 'components/questionnaires.html'
    },
    deps: []
}